import BTC from "./BTC";

const routes = [...BTC];

export default routes;
